
const BASE_DEVICE_IMAGES_URL = 'https://s3.amazonaws.com/glookoimages/devices';

export function getDeviceImageUrl(deviceId) {
  return `${BASE_DEVICE_IMAGES_URL}/${deviceId.replace(/:/g, '_')}.png`;
}
